import { render, staticRenderFns } from "./tschuki-foo.vue?vue&type=template&id=55507e58&"
import script from "./tschuki-foo.vue?vue&type=script&lang=js&"
export * from "./tschuki-foo.vue?vue&type=script&lang=js&"
import style0 from "./tschuki-foo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports